import Button from 'components/Button/Button';
import NoDataDisplay from 'components/NoDataDisplay';
import React from 'react';
import { useLabelSubscribersContext } from './LabelSubscribersContext';
import { useHistory } from 'react-router-dom';

const NoSubscribersDisplay = () => {
  const history = useHistory();
  const { filterBy, pageInfo, fetching, error } = useLabelSubscribersContext();
  const totalCount = pageInfo ? pageInfo.nodeCount : 0;

  const showAddNewSubscriber = () => {
    history.push(`${location.pathname}/add`);
  };

  const filterApplied = Object.keys(filterBy).length > 0;
  if (totalCount === 0 && !fetching && filterApplied) {
    return <NoDataDisplay text="None of your subscribers match your search." />;
  }

  if (totalCount === 0 && !fetching && !error && !filterApplied) {
    return (
      <NoDataDisplay text="You currently have no subscribers.">
        <div className="hidden-xs">
          <Button rounded onClick={showAddNewSubscriber}>
            Invite New Subscriber
          </Button>
        </div>
      </NoDataDisplay>
    );
  }

  return null;
};

export default NoSubscribersDisplay;
